import React from 'react'
import Paragraph from './Paragraph'
import Button from './Button'

const GetStarted = () => {
  return (
    <div className='get-started-wrap'>
        <div className='content'>
            <h2>Start Your Verification Today</h2>
            <Paragraph content="Click the button below to get started with the verification process and start reaping the rewards of being a trusted, verified business on FinditZ." />
            <Button variant="btn-primary" label="Start Verification" />
        </div>
    </div>
  )
}

export default GetStarted